import { takeLatest, put } from "redux-saga/effects";
import { authentication } from "state/api/authentication";
import { genFetch, tokenManager } from "coral-utility";
import {
  reqHandler,
  OAuthActionTypes,
  IRequestObject,
  RequestType,
} from "coral-utility";
import {
  authenticatedFailureAction,
  authenticatedSuccessAction,
  logoutSuccessAction,
} from "state/ducks/connect/actions";
import { getNavigationAction } from "../navigation/actions";
import { connectActionTypes } from "state/ducks/connect/types";

function withToken(): HeadersInit {
  const headers: HeadersInit = {
    Accept: "*/*",
    "Accept-Encoding": "gzip,deflate,br",
    Authorization: `Bearer ${tokenManager.getToken()}`,
    "Content-Type": "application/json",
  };

  return headers;
}

function* receivedUserData(coreJsonResponse: any) {
  yield put(getNavigationAction());
  yield put(authenticatedSuccessAction(coreJsonResponse.data));
}

function* getCurrentUser() {
  try {
    const request: IRequestObject = {
      onFetch: () => genFetch(authentication.getUserProfile())(withToken())(),
      onSuccess: receivedUserData,
      onFailure: () => put(authenticatedFailureAction()),
      onDeserialize: "json",
      type: RequestType.ONE,
    };

    yield reqHandler(request);
  } catch (error) {
    put(authenticatedFailureAction());
  }
}

function* logOut() {
  try {
    const request: IRequestObject = {
      onFetch: () => genFetch(authentication.logOut())(withToken())(),
      onSuccess: () => {
        put(logoutSuccessAction());
        tokenManager.removeToken();
        tokenManager.removeRefreshToken();
        window.location.reload();
      },
      // not sure what it means to fail to log out, will just do the same thing
      onFailure: () => {
        put(logoutSuccessAction());
        tokenManager.removeToken();
        tokenManager.removeRefreshToken();
        window.location.reload();
      },
      onDeserialize: "json",
      type: RequestType.ONE,
    };

    yield reqHandler(request);
  } catch (error) {
    // eslint-disable-next-line
    console.error(error); // tslint:disable-line:no-console
    // still want them to log out
    tokenManager.removeToken();
    tokenManager.removeRefreshToken();
    window.location.reload();
  }
}

export default function* connectSaga() {
  yield takeLatest(OAuthActionTypes.CHECK_OAUTH_TOKEN, getCurrentUser);
  yield takeLatest(connectActionTypes.USER_LOGOUT_STARTED, logOut);
}
